var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('font-awesome-icon',{staticClass:"ln-primary mr-2",attrs:{"icon":"download"}}),_c('a',{staticClass:"text-dark",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.downloadFile}},[_vm._v("Atsisiųsti aktą byloje")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }